/**
 * FY product card AJAX add to cart + success modal
 */
(function () {
  const MODAL_ID = 'fy-cart-added-modal';
  let modalReady = false;

  function apiJsUrl(routePath, fallbackPath) {
    const base = (routePath || fallbackPath || '').trim();
    if (!base) return fallbackPath + '.js';
    if (base.endsWith('.js')) return base;
    return base.replace(/\/$/, '') + '.js';
  }

  async function parseJsonResponse(res) {
    const text = await res.text();
    const trimmed = text.trim();

    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        return JSON.parse(trimmed);
      } catch (e) {
        throw new Error('Invalid response from server');
      }
    }

    if (trimmed.startsWith('<')) {
      const s = window.fyCartStrings || {};
      if (res.status === 429) {
        throw new Error(s.errorRateLimit || 'Too many requests. Please wait a moment and try again.');
      }
      if (res.status >= 500) {
        throw new Error(s.errorServer || 'Server error. Please try again later.');
      }
      throw new Error(s.errorGeneric || 'Unable to add to cart. Please refresh the page and try again.');
    }

    throw new Error('Unexpected response from server');
  }

  /** Strip Shopify <span class="money">…</span> wrappers to plain text */
  function stripMoneyHtml(value) {
    if (value == null) return '';
    const str = String(value);
    if (!str.includes('<')) return str;
    const div = document.createElement('div');
    div.innerHTML = str;
    return (div.textContent || div.innerText || '').trim();
  }

  /**
   * Shopify variant/cart prices are in cents (integer).
   * Some API fields may return dollar decimals — normalize to cents.
   */
  function normalizePriceCents(value) {
    if (value == null || value === '') return null;

    if (typeof value === 'string' && (value.includes('<') || /^\s*[$€£¥]/.test(value))) {
      return null;
    }

    const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    if (isNaN(num) || num <= 0) return null;

    if (!Number.isInteger(num) && num < 10000) {
      return Math.round(num * 100);
    }

    if (Number.isInteger(num) && num < 100) {
      return num * 100;
    }

    return Math.round(num);
  }

  /** Plain-text price using Woolman.Utils.formatMoney (Shopify currency rate) */
  function formatPlainMoney(cents, options) {
    const opts = options || { centsFrom: 'presentment' };
    const amount = normalizePriceCents(cents);
    if (amount == null) return '';

    let valueCents = amount;
    if (opts.centsFrom === 'shop' && typeof Shopify !== 'undefined' && Shopify.currency) {
      valueCents = Math.round(valueCents * (parseFloat(Shopify.currency.rate) || 1));
    }

    if (typeof Woolman !== 'undefined' && Woolman.Utils && Woolman.Utils.formatMoney) {
      return stripMoneyHtml(Woolman.Utils.formatMoney(valueCents));
    }

    return (valueCents / 100).toFixed(2);
  }

  /** Match card display: prefer Liquid-formatted price from data attribute */
  function getModalPriceText(item, meta) {
    if (meta.productPriceFormatted) {
      return stripMoneyHtml(meta.productPriceFormatted);
    }

    const fromMeta = normalizePriceCents(meta.productPrice);
    if (fromMeta != null) {
      const centsFrom = meta.productPriceFrom === 'shop' ? 'shop' : 'presentment';
      return formatPlainMoney(fromMeta, { centsFrom: centsFrom });
    }

    const fromItem = normalizePriceCents(
      item.final_price != null ? item.final_price : item.price
    );
    if (fromItem != null) {
      return formatPlainMoney(fromItem, { centsFrom: 'presentment' });
    }

    return '';
  }

  function resizeImage(url, size) {
    if (!url) return '';
    const filename = url.split('/').pop();
    const lastDot = filename.lastIndexOf('.');
    if (lastDot === -1) return url;
    const resized = filename.substring(0, lastDot) + '_' + size + filename.substring(lastDot);
    return url.replace(filename, resized);
  }

  function renderStars(rating) {
    const full = Math.floor(rating);
    let stars = '';
    for (let i = 0; i < 5; i++) {
      stars += i < full ? '★' : '☆';
    }
    return stars;
  }

  function updateCartBadges(count) {
    if (count == null || isNaN(count)) return;
    document.querySelectorAll('[data-fy-cart-count]').forEach((el) => {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
        el.classList.remove('is-empty');
      } else {
        el.setAttribute('hidden', '');
        el.classList.add('is-empty');
      }
    });
  }

  async function fetchCart() {
    const url = apiJsUrl(window.routes && window.routes.cart_url, '/cart');
    const res = await fetch(url, {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    });
    const json = await parseJsonResponse(res);
    if (!res.ok) {
      throw new Error(json.description || json.message || 'Cart fetch failed');
    }
    return json;
  }

  function getMeta(wrapper) {
    if (!wrapper) return {};
    return {
      title: wrapper.dataset.productTitle || '',
      vendor: wrapper.dataset.productVendor || '',
      image: wrapper.dataset.productImage || '',
      rating: wrapper.dataset.productRating || '',
      ratingCount: wrapper.dataset.productRatingCount || '',
      productPrice: wrapper.dataset.productPrice || '',
      productPriceFrom: wrapper.dataset.productPriceFrom || 'presentment',
      productPriceFormatted: wrapper.dataset.productPriceFormatted || ''
    };
  }

  function getProductData(wrapper) {
    const script = wrapper && wrapper.querySelector('script[data-fy-product-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.warn('[FY Cart] invalid product data', e);
      return null;
    }
  }

  function getOptionValues(variants, optionIndex) {
    const values = new Set();
    variants.forEach((v) => {
      if (v.options[optionIndex] != null) values.add(v.options[optionIndex]);
    });
    return Array.from(values);
  }

    function getOptionDisplayName(name, index, productData) {
    if (
      productData &&
      Array.isArray(productData.optionDisplayNames) &&
      productData.optionDisplayNames[index] != null
    ) {
      return productData.optionDisplayNames[index];
    }

    const strings = window.variantStrings || {};
    const identifiers = String(strings.colorSwatchIdentifiers || 'color,colour')
      .split(',')
      .map((item) => item.trim().toLowerCase())
      .filter(Boolean);
    const down = String(name || '').trim().toLowerCase();

    if (
      down &&
      identifiers.some(
        (id) => down === id || down.includes(id) || id.includes(down)
      )
    ) {
      return strings.colorOptionLabel || 'Color';
    }

    return name;
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(
      (v) =>
        v.options &&
        v.options.length === selectedOptions.length &&
        v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }

  function variantIsAvailable(v) {
    if (!v) return false;
    if (v.available === true) return true;
    if (v.available === false) return false;
    if (v.available === 'true') return true;
    if (v.available === 'false') return false;
    return Boolean(v.available);
  }

  /** True if any variant with this option value is in stock (ignores other selected options). */
  function isOptionValueInStock(variants, optionIndex, value) {
    return variants.some((v) => variantIsAvailable(v) && v.options[optionIndex] === value);
  }

  var DESKTOP_CART_DRAWER_MIN_PX = 768;

  function getCartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function prefersCartDrawer() {
    return window.matchMedia('(min-width: ' + DESKTOP_CART_DRAWER_MIN_PX + 'px)').matches;
  }

  function releaseBodyScroll() {
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('drawer-cart');
    if (drawer) {
      drawer.classList.remove('is-open', 'initialized');
    }
    releaseBodyScroll();
  }

  const FyCartModal = {
    el: null,
    pickerState: null,

    init() {
      if (modalReady) return;
      this.el = document.getElementById(MODAL_ID);
      if (!this.el) return;

      this.el.querySelectorAll('[data-fy-modal-close]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      });

      if (!this._escapeBound) {
        this._escapeBound = true;
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.el && !this.el.hidden) this.close();
        });
      }

      modalReady = true;
    },

    open() {
      this.init();
      if (!this.el) return;
      closeCartDrawer();
      this.el.hidden = false;
      this.el.removeAttribute('hidden');
      this.el.setAttribute('aria-hidden', 'false');
      this.el.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    },

    close() {
      if (!this.el) return;
      this.el.hidden = true;
      this.el.setAttribute('hidden', '');
      this.el.setAttribute('aria-hidden', 'true');
      this.el.classList.remove('is-open', 'fy-cart-modal--picker');
      releaseBodyScroll();
      closeCartDrawer();
      this.pickerState = null;
      this.setMode('success');
    },

    setMode(mode) {
      if (!this.el) return;
      const picker = this.el.querySelector('[data-fy-picker-panel]');
      const success = this.el.querySelector('[data-fy-success-panel]');
      const titleSuccess = this.el.querySelector('[data-fy-title-success]');
      const titlePicker = this.el.querySelector('[data-fy-title-picker]');
      const checkIcon = this.el.querySelector('.fy-cart-modal__check');

      if (mode === 'picker') {
        if (picker) picker.hidden = false;
        if (success) success.hidden = true;
        if (titleSuccess) titleSuccess.hidden = true;
        if (titlePicker) titlePicker.hidden = false;
        if (checkIcon) checkIcon.hidden = true;
        this.el.classList.add('fy-cart-modal--picker');
      } else {
        if (picker) picker.hidden = true;
        if (success) success.hidden = false;
        if (titleSuccess) titleSuccess.hidden = false;
        if (titlePicker) titlePicker.hidden = true;
        if (checkIcon) checkIcon.hidden = false;
        this.el.classList.remove('fy-cart-modal--picker');
      }
    },

    updatePickerVariant(variant, meta) {
      const strings = window.fyCartStrings || {};
      const imgEl = this.el.querySelector('[data-fy-picker-image]');
      const priceEl = this.el.querySelector('[data-fy-picker-price]');
      const submitBtn = this.el.querySelector('[data-fy-picker-submit]');
      const errEl = this.el.querySelector('[data-fy-picker-error]');

      this.pickerState.currentVariant = variant;

      const productData = this.pickerState && this.pickerState.productData;

      if (imgEl && variant) {
        imgEl.src = variant.image || meta.image || (productData && productData.defaultImage) || '';
      }

      if (priceEl && variant) {
        priceEl.textContent =
          stripMoneyHtml(variant.priceFormatted) ||
          formatPlainMoney(variant.price, { centsFrom: 'shop' });
      }

      if (submitBtn) {
        if (!variant || !variantIsAvailable(variant)) {
          submitBtn.disabled = true;
          submitBtn.textContent = strings.soldOut || 'Sold out';
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = strings.addToCart || 'Add to cart';
        }
      }

      if (errEl) errEl.hidden = true;
    },

    buildVariantFields(selected) {
      const container = this.el.querySelector('[data-fy-variant-fields]');
      const { productData } = this.pickerState;
      if (!container || !productData) return;

      container.innerHTML = '';
      const self = this;

      productData.optionNames.forEach((name, optionIndex) => {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'fy-cart-modal__option';
        const legend = document.createElement('legend');
        legend.className = 'fy-cart-modal__option-name';
        legend.textContent = getOptionDisplayName(name, optionIndex, productData);
        fieldset.appendChild(legend);

        const row = document.createElement('div');
        row.className = 'fy-cart-modal__option-values';

        getOptionValues(productData.variants, optionIndex).forEach((value) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fy-variant-option';
          btn.textContent = value;
          btn.dataset.optionValue = value;
          if (selected[optionIndex] === value) btn.classList.add('is-selected');

          if (!isOptionValueInStock(productData.variants, optionIndex, value)) {
            btn.classList.add('is-unavailable');
            btn.disabled = true;
          }

          btn.addEventListener('click', () => {
            if (btn.disabled) return;
            selected[optionIndex] = value;
            self.pickerState.selected = selected;
            container.querySelectorAll('.fy-cart-modal__option').forEach((fs, idx) => {
              fs.querySelectorAll('.fy-variant-option').forEach((b) => {
                const val = b.dataset.optionValue || b.textContent;
                const inStock = isOptionValueInStock(productData.variants, idx, val);
                b.classList.toggle('is-selected', selected[idx] === val);
                b.disabled = !inStock;
                b.classList.toggle('is-unavailable', !inStock);
              });
            });
            const variant = findVariant(productData.variants, selected);
            self.updatePickerVariant(variant, self.pickerState.meta);
          });

          row.appendChild(btn);
        });

        fieldset.appendChild(row);
        container.appendChild(fieldset);
      });

      this.pickerState.selected = selected;
    },

    showPicker(wrapper, meta, productData) {
      this.init();
      if (!this.el) return;

      const firstAvailable =
        productData.variants.find((v) => variantIsAvailable(v)) || productData.variants[0];
      const selected = firstAvailable ? [...firstAvailable.options] : [];

      this.pickerState = { wrapper, meta, productData, selected };

      const titleEl = this.el.querySelector('[data-fy-picker-title]');
      const vendorEl = this.el.querySelector('[data-fy-picker-vendor]');
      const vendorText = productData.vendor || meta.vendor;

      if (titleEl) titleEl.textContent = productData.title || meta.title;
      if (vendorEl) {
        if (vendorText) {
          vendorEl.textContent = '© ' + vendorText;
          vendorEl.hidden = false;
        } else {
          vendorEl.hidden = true;
        }
      }

      this.setMode('picker');
      this.buildVariantFields(selected);
      this.updatePickerVariant(findVariant(productData.variants, selected), meta);

      const submitBtn = this.el.querySelector('[data-fy-picker-submit]');
      if (submitBtn && !submitBtn.dataset.fyBound) {
        submitBtn.dataset.fyBound = 'true';
        submitBtn.addEventListener('click', () => this.onPickerSubmit());
      }

      this.open();
    },

    async onPickerSubmit() {
      if (addInProgress) return;
      const variant = this.pickerState && this.pickerState.currentVariant;
      const meta = this.pickerState && this.pickerState.meta;
      if (!variant || !variantIsAvailable(variant)) return;

      const submitBtn = this.el.querySelector('[data-fy-picker-submit]');
      addInProgress = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
      }

      try {
        const pickerMeta = Object.assign({}, meta, {
          productPrice: String(variant.price),
          productPriceFrom: 'shop',
          productPriceFormatted: stripMoneyHtml(variant.priceFormatted),
          image: variant.image || meta.image
        });

        await executeAddToCart(variant.id, 1, pickerMeta, {
          lineItemOverrides: {
            product_title: this.pickerState.productData.title,
            image: variant.image,
            price: variant.price,
            final_price: variant.price
          }
        });
      } catch (err) {
        const errEl = this.el.querySelector('[data-fy-picker-error]');
        if (errEl) {
          errEl.textContent = err.message || 'Add to cart failed';
          errEl.hidden = false;
        }
        console.error('[FY Cart]', err);
      } finally {
        addInProgress = false;
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          this.updatePickerVariant(variant, meta);
        }
      }
    },

    updateShipping(cart) {
      if (!this.el || !cart) return;
      const wrap = this.el.querySelector('[data-fy-shipping-wrap]');
      const textEl = this.el.querySelector('[data-fy-shipping-text]');
      const bar = this.el.querySelector('[data-fy-shipping-bar]');
      const threshold = parseInt(this.el.dataset.threshold, 10);

      if (!wrap || !textEl || !bar) return;

      if (!threshold || threshold <= 0) {
        wrap.hidden = true;
        return;
      }

      wrap.hidden = false;
      const cartTotalShop = cart.total_price || 0;
      const shippingConfirmed = cart.shippingConfirmed !== false;

      const strings = window.fyCartStrings || {};
      const progress = Math.min(
        100,
        Math.max(cartTotalShop > 0 ? 5 : 0, Math.round((cartTotalShop / threshold) * 100))
      );

      if (shippingConfirmed && cartTotalShop >= threshold) {
        textEl.textContent = strings.shippingFree || "🎉 Congrats! You've earned free shipping!";
        bar.style.width = '100%';
      } else {
        const missing = Math.max(0, threshold - cartTotalShop);
        const template = strings.shippingProgress || 'Add [amount] more for free shipping';
        textEl.textContent = template.replace('[amount]', formatPlainMoney(missing, { centsFrom: 'shop' }));
        bar.style.width = (shippingConfirmed ? progress : Math.min(progress, 99)) + '%';
      }
    },

    fill(item, meta) {
      const img = this.el.querySelector('[data-fy-product-image]');
      const title = this.el.querySelector('[data-fy-product-title]');
      const vendor = this.el.querySelector('[data-fy-product-vendor]');
      const price = this.el.querySelector('[data-fy-product-price]');
      const ratingWrap = this.el.querySelector('[data-fy-product-rating]');
      const stars = this.el.querySelector('[data-fy-product-stars]');
      const reviewCount = this.el.querySelector('[data-fy-review-count]');

      const imageUrl = item.image ? resizeImage(item.image, '240x') : meta.image || '';
      if (img) {
        img.src = imageUrl;
        img.alt = item.product_title || meta.title || '';
      }
      if (title) title.textContent = item.product_title || meta.title || '';

      const vendorText = meta.vendor || item.vendor || '';
      if (vendor) {
        if (vendorText) {
          vendor.textContent = '© ' + vendorText;
          vendor.hidden = false;
        } else {
          vendor.hidden = true;
        }
      }

      if (price) {
        price.textContent = getModalPriceText(item, meta);
      }

      const ratingVal = parseFloat(meta.rating);
      const ratingCount = parseInt(meta.ratingCount, 10);
      if (ratingWrap && stars && reviewCount) {
        if (!isNaN(ratingVal) && ratingVal > 0) {
          ratingWrap.hidden = false;
          stars.textContent = renderStars(ratingVal);
          const countTemplate = (window.fyCartStrings && window.fyCartStrings.reviews) || '[count] reviews';
          reviewCount.textContent = countTemplate.replace('[count]', ratingCount || 0);
        } else {
          ratingWrap.hidden = true;
        }
      }
    },

    async show(item, meta, cartSnapshot) {
      this.init();
      if (!this.el) return;

      this.setMode('success');
      this.fill(item, meta);
      this.open();

      if (cartSnapshot && cartSnapshot.total_price != null) {
        this.updateShipping(Object.assign({ shippingConfirmed: true }, cartSnapshot));
        updateCartBadges(cartSnapshot.item_count);
      }

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { skipDrawer: true, cart: cartSnapshot || null },
        })
      );
    }
  };

  let addInProgress = false;

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    const loader = btn.querySelector('.fy-btn-loading');
    if (loading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');
      if (loader) loader.hidden = false;
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading');
      if (loader) loader.hidden = true;
    }
  }

  function lineItemFromMeta(meta, variantId) {
    const price = normalizePriceCents(meta.productPrice);
    return {
      product_title: meta.title,
      image: meta.image,
      vendor: meta.vendor,
      price: price,
      final_price: price,
      variant_id: variantId
    };
  }

  async function requestAddToCart(variantId, quantity) {
    const url = apiJsUrl(window.routes && window.routes.cart_add_url, '/cart/add');
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity));

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: formData
    });

    const json = await parseJsonResponse(res);
    if (!res.ok) {
      throw new Error(json.description || json.message || 'Add to cart failed');
    }
    return json;
  }

  async function executeAddToCart(variantId, quantity, meta, options) {
    const overrides = (options && options.lineItemOverrides) || {};
    const json = await requestAddToCart(variantId, quantity);

    let cartSnapshot = null;
    try {
      cartSnapshot = await fetchCart();
    } catch (e) {
      console.warn('[FY Cart] cart fetch skipped', e);
    }

    const lineItem = Object.assign(
      {},
      lineItemFromMeta(meta, variantId),
      json.items ? json.items[0] : json,
      overrides
    );
    await FyCartModal.show(lineItem, meta, cartSnapshot);
  }

  async function handleAddToCart(form) {
    if (addInProgress) return;

    const submitBtn = form.querySelector('[data-fy-add-btn], [type="submit"]');
    if (!submitBtn || submitBtn.disabled) return;
    if (submitBtn.getAttribute('aria-disabled') === 'true') return;

    const wrapper = form.closest('[data-fy-card-form]');
    const meta = getMeta(wrapper);

    const productData = getProductData(wrapper);
    if (productData && productData.variants && productData.variants.length) {
      FyCartModal.showPicker(wrapper, meta, productData);
      return;
    }

    const formData = new FormData(form);
    const variantId = parseInt(formData.get('id'), 10);
    const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);

    if (!variantId || isNaN(variantId)) return;

    addInProgress = true;
    setButtonLoading(submitBtn, true);

    try {
      await executeAddToCart(variantId, quantity, meta);
    } catch (err) {
      const s = window.fyCartStrings || {};
      alert(err.message || s.errorGeneric || 'Unable to add to cart. Please try again.');
      console.error('[FY Cart]', err);
    } finally {
      addInProgress = false;
      setButtonLoading(submitBtn, false);
    }
  }

  function onDocumentSubmit(e) {
    const form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.closest('[data-fy-card-form]')) return;

    e.preventDefault();
    e.stopPropagation();
    handleAddToCart(form);
  }

  function onAddButtonClick(e) {
    const btn = e.target.closest('[data-fy-add-btn]');
    if (!btn) return;
    const form = btn.closest('[data-fy-card-form] form, form.fy-card-form__inner');
    if (!form || !form.closest('[data-fy-card-form]')) return;

    e.preventDefault();
    e.stopPropagation();
    handleAddToCart(form);
  }

  function openCartDrawer() {
    const drawer = document.getElementById('drawer-cart');
    if (!drawer) {
      window.location.assign(getCartUrl());
      return;
    }

    const cartItems = drawer.querySelector('cart-items');
    if (cartItems && typeof cartItems.renderItems === 'function') {
      cartItems.renderItems();
    }

    drawer.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden');
  }

  function onHeaderCartClick(e) {
    const trigger = e.target.closest('a.fy-cart-trigger, a.fy-mobile-cart');
    if (!trigger || trigger.hasAttribute('data-fy-view-cart')) return;

    const cartUrl = trigger.getAttribute('href') || getCartUrl();

    e.preventDefault();
    e.stopPropagation();

    if (!prefersCartDrawer()) {
      window.location.assign(cartUrl);
      return;
    }

    const drawer = document.getElementById('drawer-cart');
    if (drawer && drawer.classList.contains('is-open')) {
      closeCartDrawer();
      return;
    }

    if (drawer) {
      openCartDrawer();
      return;
    }

    window.location.assign(cartUrl);
  }

  function onViewCartClick(e) {
    const trigger = e.target.closest('[data-fy-view-cart]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    FyCartModal.close();
    window.location.href = getCartUrl();
  }

  function init() {
    FyCartModal.init();
    closeCartDrawer();

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const drawer = document.getElementById('drawer-cart');
      if (drawer && drawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    document.addEventListener('submit', onDocumentSubmit, true);
    document.addEventListener('click', onAddButtonClick, true);
    document.addEventListener('click', onHeaderCartClick, true);
    document.addEventListener('click', onViewCartClick, true);

    document.addEventListener(
      'click',
      function (e) {
        const closeBtn = e.target.closest('#drawer-cart [data-close], #drawer-cart [data-overlay]');
        if (!closeBtn) return;
        e.preventDefault();
        closeCartDrawer();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FyCardAddToCart = {
    modal: FyCartModal,
    updateCartBadges,
    fetchCart,
    openCartDrawer,
    closeCartDrawer
  };
})();
